var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isVisible && _vm.loaded && _vm.noSplit
        ? _c("ItpButton", {
            attrs: {
              disabled: !_vm.invoice.meta.has_print_document,
              variant: "light",
              icon: _vm.printerIcon,
              href: _vm.invoice.links.print_url,
              target: "_blank",
              "use-auth": "",
              "show-spinner": ""
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isVisible && _vm.loaded && !_vm.noSplit
        ? _c(
            "b-dropdown",
            {
              staticClass: "ml-auto mr-2 border",
              attrs: { variant: "light", split: "" },
              on: {
                click: function($event) {
                  return _vm.evh_6804155476809633_click($event, {})
                }
              }
            },
            [
              _c(
                "template",
                {
                  attrs: {
                    title: _vm._f("pgettext")("Open print document", "Invoice")
                  },
                  slot: "button-content"
                },
                [
                  _vm.actions.openDocument && _vm.actions.openDocument.isRunning
                    ? _c("b-spinner", {
                        staticClass: "mr-1",
                        attrs: { spinning: "", type: "grow" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    {
                      class: [
                        "mr-1",
                        !_vm.invoice.meta.has_print_document
                          ? "text-muted"
                          : null
                      ],
                      attrs: {
                        title: _vm._f("pgettext")(
                          "Open print document in a new browser tab.",
                          "Invoice"
                        )
                      }
                    },
                    [_c("ItpIcon", { attrs: { name: _vm.printerIcon } })],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.invoice.meta.invoice_view_upload_enabled
                ? _c(
                    "b-dropdown-item-button",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.evh_5974459770896956_clickPreventStop(
                            $event,
                            {}
                          )
                        }
                      }
                    },
                    [
                      _c("ItpText", {
                        attrs: {
                          text: _vm._f("pgettext")(
                            "Upload print document",
                            "Invoice|Command"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.invoice.meta.has_print_document &&
              _vm.invoice.meta.invoice_view_delete_enabled
                ? _c(
                    "b-dropdown-item-button",
                    {
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.evh_8852205820859826_clickPreventStop(
                            $event,
                            {}
                          )
                        }
                      }
                    },
                    [
                      _c("ItpText", {
                        attrs: {
                          text: _vm._f("pgettext")(
                            "Delete print document",
                            "Invoice|Command"
                          )
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }